import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-57cee886"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "horizontal-ads"
}
const _hoisted_2 = { class: "ha-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "head-text" }, "Featured Account Options"),
  /*#__PURE__*/_createElementVNode("th", { class: "sponsored-head" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sponsored-text" }, "SPONSORED LISTINGS")
  ])
], -1))
const _hoisted_4 = {
  colspan: "3",
  class: "anchor-tag four-a-color"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"4px","padding-right":"4px","color":"#aaa"} }, " | ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_how_da_gets_paid = _resolveComponent("how-da-gets-paid")!
  const _component_ad_disclosure_tooltip = _resolveComponent("ad-disclosure-tooltip")!
  const _component_horizontal_ad = _resolveComponent("horizontal-ad")!

  return (_ctx.itemsRendered)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            _hoisted_3,
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_4, [
                _createVNode(_component_how_da_gets_paid),
                _createTextVNode(),
                _hoisted_5,
                _createTextVNode(),
                _createVNode(_component_ad_disclosure_tooltip)
              ])
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ads, (ad) => {
                return (_openBlock(), _createBlock(_component_horizontal_ad, {
                  key: ad.id,
                  ad: ad
                }, null, 8, ["ad"]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}